export const DefaultColors = {
  white: "#fff",
  black: "#000",
  black_50: "rgba(0, 0, 0, 0.75)",
  black_10: "rgba(0, 0, 0, 0.075)",
  transparent: "transparent",
  black_transparent_30: "rgba(0,0,0, .3)",

  gray_25: "#fbfbfb",
  gray_40: "#f2f3f4",
  gray_50: "#f9f9f9",
  gray_60: "#b3b3b3",
  gray_70: "#fef6ea",
  gray_75: "#f6f6f6",
  gray_80: "#eeeeee",
  gray_85: "#ecedec",
  gray_90: "#fcf8e3",
  gray_95: "#d9d9d9",
  gray_100: "#ececec",
  gray_110: "#e9e9e9",
  gray_120: "#e5e9ec",
  gray_123: "#efefef",
  gray_125: "#e4e4e4",
  gray_130: "#f2dede",
  gray_135: "#ffdfdf",
  gray_200: "#dddddd",
  gray_201: "#f2f2f2",
  gray_202: "#f4f4f4",
  gray_205: "#f5f5f5",
  gray_206: "#e1e1e1",
  gray_210: "#dff0d8",
  gray_211: "#d3d3d3",
  gray_213: "#d4d4d4",
  gray_214: "#c4c4c4",
  gray_215: "#cccccc",
  gray_220: "#ccd0d3",
  gray_221: "#cdcdcd",
  gray_225: "#c1c9cd",
  gray_230: "#d9edf7",
  gray_235: "#c1bebe",
  gray_240: "#cfcfcf",
  gray_245: "#8b8b8b",
  gray_250: "#808080",
  gray_260: "#959ea4",
  gray_280: "#999999",
  gray_285: "#b7aab5",
  gray_300: "#777777",
  gray_305: "#757575",
  gray_320: "#dedce0",
  gray_330: "#666666",
  gray_350: "#6b546a",
  gray_400: "#5e5e5e",
  gray_420: "#555555",
  gray_430: "#e3e3e3",
  gray_500: "#333333",
  gray_600: "#f1f1f1",
  gray_700: "#aaaaaa",
  gray_720: "#b6b6b6",
  gray_740: "#b6a8b4",
  gray_750: "#b7b7b7",
  gray_755: "#ebebeb",
  gray_800: "#4a4a4a",
  gray_810: "#525252",
  gray_820: "#40465d",
  gray_850: "#554854",
  gray_855: "#8b91a0",
  gray_860: "#9b9b9b",
  gray_865: "#4b444a",
  gray_870: "#929292",
  gray_880: "#f0f0f0",
  gray_885: "#cfcfd1",
  gray_890: "#756372",
  gray_895: "#989898",
  gray_900: "#323639",
  gray_905: "#525659",
  gray_910: "#444059",
  gray_915: "#645862",
  gray_920: "#757575",
  gray_925: "#9c9c9c",
  gray_930: "#ddcfac",
  gray_935: "#5f6368",
  gray_950: "#ece4d0",
  gray_1000: "#ebe8e8",
  gray_1010: "#e6e6e6",
  gray_1050: "#e0e6f0",
  gray_1060: "#c6c6c6",
  gray_1100: "#ededed",
  gray_1110: "#ecf8ff",
  gray_1120: "#8e818c",
  gray_1150: "#212121",

  blue_25: "#eef6fb",
  blue_30: "#cfe7ff",
  blue_50: "#92cbf1",
  blue_60: "#56bbdb",
  blue_100: "#4690d1",
  blue_120: "#2791c6",
  blue_130: "#2196f3",
  blue_140: "#428bca",
  blue_150: "#add2f7",
  blue_200: "#3395ff",
  blue_210: "#287ec7",
  blue_250: "#2879c7",
  blue_300: "#0478c6",
  blue_305: "#0055b0",
  blue_310: "#00829b",
  blue_315: "#08c",
  blue_320: "#217c99",
  blue_325: "#04c",
  blue_330: "#0055b0",
  blue_350: "#31708f",
  blue_400: "#024b7b",
  blue_450: "#002a80",
  blue_500: "#0000ff",

  yellow_40: "#fcffd9",
  yellow_90: "#fbdba0",
  yellow_100: "#fde19a",
  yellow_105: "#fdd49a",
  yellow_110: "#fdf59a",
  yellow_120: "#fbed50",
  yellow_130: "#ffff00",
  yellow_400: "#ffd400",
  yellow_410: "#fedb97",

  orange_200: "#eda04f",
  orange_300: "#ee9a02",
  orange_350: "#e7a257",
  orange_360: "#c3a565",
  orange_380: "#ff8c40",
  orange_400: "#ef7400",
  orange_420: "#ff6600",
  orange_500: "#ff9900",
  orange_510: "#bf5000",
  orange_550: "#bf5000",

  brown_300: "#8a6d3b",
  brown_310: "#7f707d",
  brown_320: "#7f707d",

  red: "red",
  red_50: "#ffdfe0",
  red_70: "#f7wbfb9",
  red_90: "#ce8483",
  red_100: "#e87d7d",
  red_300: "#f35958",
  red_320: "#e05251",
  red_380: "#ec3f41",
  red_390: "#843534",
  red_400: "#a94442",
  red_405: "#b74540",
  red_410: "#bc2b43",
  red_500: "#cc2d30",
  red_550: "#c60000",
  red_900: "#ff0000",
  red_905: "#cf4444",
  red_910: "#c60000",

  dark_blue_170: "#7e9fc2",
  dark_blue_180: "#8e95b4",
  dark_blue_200: "#666d85",
  dark_blue_210: "#7aa3d4",
  dark_blue_220: "#537fad",
  dark_blue_300: "#40465d",
  dark_blue_400: "#272c40",

  green_200: "#d8f0ea",
  green_210: "#c0e8dc",
  green_250: "#09998d",
  green_270: "#47bcb3",
  green_300: "#008859",
  green_310: "#4cb992",
  green_400: "#2b542c",
  green_500: "#3c763d",
  green_505: "#119264",
  green_510: "#008859",
  green_520: "#00794f",
  green_630: "#51b893",
  green_640: "#67b168",
  green_650: "#b1dac6",
  green_700: "#008000",
  green_710: "#30b382",
  green_750: "#008859",
  green_800: "#008859",

  purple: "#6a546a",

  yellow: "#008859",

  yellow_inprogress: "#BEA66E",
}

